import { render, staticRenderFns } from "./publicToPublic.vue?vue&type=template&id=63f88afa&scoped=true&"
import script from "./publicToPublic.vue?vue&type=script&lang=js&"
export * from "./publicToPublic.vue?vue&type=script&lang=js&"
import style0 from "./publicToPublic.vue?vue&type=style&index=0&id=63f88afa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f88afa",
  null
  
)

export default component.exports